module.exports = __webpack_public_path__ + "static/img/158.ce852c0.png";